import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=a4d2fe84&scoped=true&"
import script from "./ProductInfo.vue?vue&type=script&lang=js&"
export * from "./ProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=a4d2fe84&lang=scss&scoped=true&"
import style1 from "./ProductInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d2fe84",
  null
  
)

export default component.exports